import {convertNodeToElement} from 'react-html-parser';

import {hasHref} from './node-processors-utils';

import type {ProcessorType} from './node-processors-types';

export const SkipProcessorsIfCredentialsProcessor: ProcessorType = {
  tag: 'a',
  condition: (node) =>
    hasHref(node) && node.attribs.href.match(/^[a-zA-Z]+:\/\/[^/]+@/) != null,

  // fix for IE edge which will die if there are credentials in URL
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8004284/
  processor: (node, index, transform) => [
    null,
    convertNodeToElement(node, index, transform),
  ],
};
